import { useContext } from 'react';
import { AiCopilotContext } from './AiCopilotProvider';

export function useAiCopilot() {
  const context = useContext(AiCopilotContext);

  if (context === undefined) {
    throw new Error('useAiCopilot must be used inside AiCopilotProvider');
  }

  return context;
}
